/**
 * Do not edit directly
 * Generated on Fri, 02 Dec 2022 22:48:14 GMT
 */

module.exports = {
  "globals": {
    "fontFamilies": {
      "base": {
        "value": "Open Sans",
        "type": "fontFamilies",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "Open Sans",
          "type": "fontFamilies"
        },
        "name": "hb-ds-globals-font-families-base",
        "attributes": {},
        "path": [
          "globals",
          "fontFamilies",
          "base"
        ]
      }
    },
    "fontWeights": {
      "light": {
        "value": "300",
        "type": "fontWeights",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "300",
          "type": "fontWeights"
        },
        "name": "hb-ds-globals-font-weights-light",
        "attributes": {},
        "path": [
          "globals",
          "fontWeights",
          "light"
        ]
      },
      "regular": {
        "value": "400",
        "type": "fontWeights",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "400",
          "type": "fontWeights"
        },
        "name": "hb-ds-globals-font-weights-regular",
        "attributes": {},
        "path": [
          "globals",
          "fontWeights",
          "regular"
        ]
      },
      "semibold": {
        "value": "600",
        "type": "fontWeights",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "600",
          "type": "fontWeights"
        },
        "name": "hb-ds-globals-font-weights-semibold",
        "attributes": {},
        "path": [
          "globals",
          "fontWeights",
          "semibold"
        ]
      },
      "bold": {
        "value": "700",
        "type": "fontWeights",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "700",
          "type": "fontWeights"
        },
        "name": "hb-ds-globals-font-weights-bold",
        "attributes": {},
        "path": [
          "globals",
          "fontWeights",
          "bold"
        ]
      }
    },
    "fontSize": {
      "0": {
        "value": "0",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "0",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-0",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "0"
        ]
      },
      "100": {
        "value": "10",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "10",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-100",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "100"
        ]
      },
      "200": {
        "value": "12.5",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "12.5",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-200",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "200"
        ]
      },
      "300": {
        "value": "14",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "14",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-300",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "300"
        ]
      },
      "400": {
        "value": "15",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "15",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-400",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "400"
        ]
      },
      "500": {
        "value": "17",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "17",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-500",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "500"
        ]
      },
      "600": {
        "value": "21",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "21",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-600",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "600"
        ]
      },
      "700": {
        "value": "28",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "28",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-700",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "700"
        ]
      },
      "800": {
        "value": "34",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "34",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-800",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "800"
        ]
      },
      "900": {
        "value": "47",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "47",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-900",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "900"
        ]
      },
      "1000": {
        "value": "58",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "58",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-1000",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "1000"
        ]
      },
      "1100": {
        "value": "79",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "79",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-1100",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "1100"
        ]
      },
      "1200": {
        "value": "96",
        "type": "fontSizes",
        "filePath": "tokens/globals/fonts.json",
        "isSource": true,
        "original": {
          "value": "96",
          "type": "fontSizes"
        },
        "name": "hb-ds-globals-font-size-1200",
        "attributes": {},
        "path": [
          "globals",
          "fontSize",
          "1200"
        ]
      }
    },
    "letterSpacing": {
      "0": {
        "value": "0em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "0%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-0",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "0"
        ]
      },
      "100": {
        "value": "0.012em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "1.2%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-100",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "100"
        ]
      },
      "200": {
        "value": "0em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "0%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-200",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "200"
        ]
      },
      "300": {
        "value": "-0.0014000000000000002em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-0.14%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-300",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "300"
        ]
      },
      "400": {
        "value": "-0.002em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-0.2%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-400",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "400"
        ]
      },
      "500": {
        "value": "-0.0026em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-0.26%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-500",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "500"
        ]
      },
      "600": {
        "value": "-0.01em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-1%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-600",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "600"
        ]
      },
      "700": {
        "value": "-0.012em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-1.2%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-700",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "700"
        ]
      },
      "800": {
        "value": "-0.015em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-1.5%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-800",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "800"
        ]
      },
      "900": {
        "value": "-0.017em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-1.7%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-900",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "900"
        ]
      },
      "1000": {
        "value": "-0.015em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-1.5%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-1000",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "1000"
        ]
      },
      "1100": {
        "value": "-0.006999999999999999em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-0.7%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-1100",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "1100"
        ]
      },
      "1200": {
        "value": "-0.013000000000000001em",
        "type": "letterSpacing",
        "filePath": "tokens/globals/letterSpacing.json",
        "isSource": true,
        "original": {
          "value": "-1.3%",
          "type": "letterSpacing"
        },
        "name": "hb-ds-globals-letter-spacing-1200",
        "attributes": {},
        "path": [
          "globals",
          "letterSpacing",
          "1200"
        ]
      }
    },
    "lineHeights": {
      "0": {
        "value": "100%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "100%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-0",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "0"
        ]
      },
      "100": {
        "value": "160%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "160%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-100",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "100"
        ]
      },
      "200": {
        "value": "160%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "160%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-200",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "200"
        ]
      },
      "300": {
        "value": "142.9%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "142.9%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-300",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "300"
        ]
      },
      "400": {
        "value": "160%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "160%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-400",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "400"
        ]
      },
      "500": {
        "value": "141.2%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "141.2%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-500",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "500"
        ]
      },
      "600": {
        "value": "152.4%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "152.4%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-600",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "600"
        ]
      },
      "700": {
        "value": "142.9%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "142.9%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-700",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "700"
        ]
      },
      "800": {
        "value": "129.4%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "129.4%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-800",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "800"
        ]
      },
      "900": {
        "value": "102.1%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "102.1%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-900",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "900"
        ]
      },
      "1000": {
        "value": "117.2%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "117.2%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-1000",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "1000"
        ]
      },
      "1100": {
        "value": "121.5%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "121.5%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-1100",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "1100"
        ]
      },
      "1200": {
        "value": "125%",
        "type": "lineHeights",
        "filePath": "tokens/globals/lineHeights.json",
        "isSource": true,
        "original": {
          "value": "125%",
          "type": "lineHeights"
        },
        "name": "hb-ds-globals-line-heights-1200",
        "attributes": {},
        "path": [
          "globals",
          "lineHeights",
          "1200"
        ]
      }
    }
  },
  "color": {
    "base": {
      "pink": {
        "50": {
          "value": "hsla(335, 52.4%, 91.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(335, 52.4%, 91.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "50"
          ]
        },
        "100": {
          "value": "hsla(335, 50.8%, 87.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(335, 50.8%, 87.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "100"
          ]
        },
        "200": {
          "value": "hsla(334, 65.7%, 79.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 65.7%, 79.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "200"
          ]
        },
        "300": {
          "value": "hsla(334, 77.9%, 69.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 77.9%, 69.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "300"
          ]
        },
        "350": {
          "value": "hsla(333, 68.5%, 65.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(333, 68.5%, 65.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "350"
          ]
        },
        "400": {
          "value": "hsla(334, 79.6%, 61.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 79.6%, 61.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "400"
          ]
        },
        "450": {
          "value": "hsla(334, 67.3%, 58%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 67.3%, 58%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "450"
          ]
        },
        "500": {
          "value": "hsla(334, 78.1%, 57.2%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 78.1%, 57.2%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "500"
          ]
        },
        "550": {
          "value": "hsla(334, 70.9%, 49.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 70.9%, 49.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "550"
          ]
        },
        "600": {
          "value": "hsla(334, 72.3%, 49.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 72.3%, 49.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "600"
          ]
        },
        "650": {
          "value": "hsla(334, 79.5%, 45.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 79.5%, 45.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "650"
          ]
        },
        "700": {
          "value": "hsla(334, 85.7%, 38.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 85.7%, 38.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "700"
          ]
        },
        "750": {
          "value": "hsla(334, 93.8%, 31.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 93.8%, 31.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "750"
          ]
        },
        "800": {
          "value": "hsla(334, 92.3%, 25.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 92.3%, 25.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "800"
          ]
        },
        "850": {
          "value": "hsla(334, 98.1%, 21%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 98.1%, 21%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "850"
          ]
        },
        "900": {
          "value": "hsla(334, 100%, 12.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 100%, 12.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-pink-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "pink",
            "900"
          ]
        }
      },
      "blue": {
        "50": {
          "value": "hsla(202, 52.4%, 91.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(202, 52.4%, 91.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "50"
          ]
        },
        "100": {
          "value": "hsla(204, 68%, 85.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(204, 68%, 85.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "100"
          ]
        },
        "150": {
          "value": "hsla(202, 69.5%, 79.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(202, 69.5%, 79.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "150"
          ]
        },
        "200": {
          "value": "hsla(205, 74.8%, 78.2%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(205, 74.8%, 78.2%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "200"
          ]
        },
        "250": {
          "value": "hsla(202, 73.3%, 67.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(202, 73.3%, 67.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "250"
          ]
        },
        "300": {
          "value": "hsla(207, 77.9%, 69.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(207, 77.9%, 69.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "300"
          ]
        },
        "350": {
          "value": "hsla(202, 73.8%, 56.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(202, 73.8%, 56.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "350"
          ]
        },
        "400": {
          "value": "hsla(208, 79.6%, 61.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(208, 79.6%, 61.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "400"
          ]
        },
        "450": {
          "value": "hsla(204, 76.1%, 52.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(204, 76.1%, 52.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "450"
          ]
        },
        "500": {
          "value": "hsla(209, 78.1%, 57.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(209, 78.1%, 57.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "500"
          ]
        },
        "550": {
          "value": "hsla(205, 79.9%, 48.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(205, 79.9%, 48.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "550"
          ]
        },
        "600": {
          "value": "hsla(210, 74.8%, 53.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 74.8%, 53.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "600"
          ]
        },
        "650": {
          "value": "hsla(209, 100%, 38.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(209, 100%, 38.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "650"
          ]
        },
        "700": {
          "value": "hsla(211, 85.7%, 38.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(211, 85.7%, 38.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "700"
          ]
        },
        "750": {
          "value": "hsla(210, 100%, 31%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 100%, 31%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "750"
          ]
        },
        "800": {
          "value": "hsla(212, 92.3%, 25.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(212, 92.3%, 25.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "800"
          ]
        },
        "850": {
          "value": "hsla(211, 100%, 21%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(211, 100%, 21%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "850"
          ]
        },
        "900": {
          "value": "hsla(212, 100%, 12.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(212, 100%, 12.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-blue-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "blue",
            "900"
          ]
        }
      },
      "green": {
        "50": {
          "value": "hsla(134, 52.4%, 91.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(134, 52.4%, 91.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "50"
          ]
        },
        "100": {
          "value": "hsla(134, 67.6%, 85.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(134, 67.6%, 85.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "100"
          ]
        },
        "150": {
          "value": "hsla(134, 47.6%, 75.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(134, 47.6%, 75.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "150"
          ]
        },
        "200": {
          "value": "hsla(135, 74.3%, 78.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(135, 74.3%, 78.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "200"
          ]
        },
        "250": {
          "value": "hsla(134, 43.8%, 60.2%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(134, 43.8%, 60.2%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "250"
          ]
        },
        "300": {
          "value": "hsla(135, 77.3%, 70.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(135, 77.3%, 70.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "300"
          ]
        },
        "350": {
          "value": "hsla(135, 57.7%, 52.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(135, 57.7%, 52.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "350"
          ]
        },
        "400": {
          "value": "hsla(135, 79.2%, 62.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(135, 79.2%, 62.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "400"
          ]
        },
        "450": {
          "value": "hsla(135, 62.8%, 49.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(135, 62.8%, 49.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "450"
          ]
        },
        "500": {
          "value": "hsla(136, 74.2%, 54.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 74.2%, 54.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "500"
          ]
        },
        "550": {
          "value": "hsla(136, 80.3%, 43.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 80.3%, 43.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "550"
          ]
        },
        "600": {
          "value": "hsla(136, 74.5%, 46.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 74.5%, 46.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "600"
          ]
        },
        "650": {
          "value": "hsla(136, 86.1%, 39.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 86.1%, 39.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "650"
          ]
        },
        "700": {
          "value": "hsla(136, 81.1%, 39.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 81.1%, 39.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "700"
          ]
        },
        "750": {
          "value": "hsla(136, 90%, 31.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 90%, 31.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "750"
          ]
        },
        "800": {
          "value": "hsla(136, 86.6%, 26.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 86.6%, 26.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "800"
          ]
        },
        "850": {
          "value": "hsla(136, 92.6%, 21.2%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(136, 92.6%, 21.2%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "850"
          ]
        },
        "900": {
          "value": "hsla(135, 93.9%, 12.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(135, 93.9%, 12.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-green-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "green",
            "900"
          ]
        }
      },
      "orange": {
        "50": {
          "value": "hsla(27, 52.4%, 91.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(27, 52.4%, 91.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "50"
          ]
        },
        "100": {
          "value": "hsla(26, 67.6%, 85.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(26, 67.6%, 85.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "100"
          ]
        },
        "150": {
          "value": "hsla(27, 77.2%, 84.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(27, 77.2%, 84.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "150"
          ]
        },
        "200": {
          "value": "hsla(24, 74.3%, 78.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(24, 74.3%, 78.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "200"
          ]
        },
        "250": {
          "value": "hsla(27, 84.5%, 77.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(27, 84.5%, 77.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "250"
          ]
        },
        "300": {
          "value": "hsla(23, 77.3%, 70.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(23, 77.3%, 70.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "300"
          ]
        },
        "350": {
          "value": "hsla(27, 90%, 64.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(27, 90%, 64.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "350"
          ]
        },
        "400": {
          "value": "hsla(22, 79.2%, 62.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(22, 79.2%, 62.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "400"
          ]
        },
        "450": {
          "value": "hsla(25, 87.4%, 59.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(25, 87.4%, 59.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "450"
          ]
        },
        "500": {
          "value": "hsla(21, 77.6%, 58%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(21, 77.6%, 58%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "500"
          ]
        },
        "550": {
          "value": "hsla(24, 82.8%, 54.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(24, 82.8%, 54.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "550"
          ]
        },
        "600": {
          "value": "hsla(20, 70.5%, 50.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(20, 70.5%, 50.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "600"
          ]
        },
        "650": {
          "value": "hsla(23, 77.9%, 49.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(23, 77.9%, 49.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "650"
          ]
        },
        "700": {
          "value": "hsla(20, 81.1%, 39.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(20, 81.1%, 39.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "700"
          ]
        },
        "750": {
          "value": "hsla(21, 89.6%, 33.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(21, 89.6%, 33.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "750"
          ]
        },
        "800": {
          "value": "hsla(19, 86.6%, 26.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(19, 86.6%, 26.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "800"
          ]
        },
        "850": {
          "value": "hsla(20, 93%, 22.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(20, 93%, 22.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "850"
          ]
        },
        "900": {
          "value": "hsla(18, 93.9%, 12.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(18, 93.9%, 12.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-orange-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "orange",
            "900"
          ]
        }
      },
      "red": {
        "50": {
          "value": "hsla(357, 66.7%, 94.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(357, 66.7%, 94.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "50"
          ]
        },
        "100": {
          "value": "hsla(358, 59%, 83.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 59%, 83.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "100"
          ]
        },
        "150": {
          "value": "hsla(357, 66.3%, 82.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(357, 66.3%, 82.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "150"
          ]
        },
        "200": {
          "value": "hsla(358, 67.5%, 77.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 67.5%, 77.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "200"
          ]
        },
        "250": {
          "value": "hsla(358, 77.6%, 75.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 77.6%, 75.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "250"
          ]
        },
        "300": {
          "value": "hsla(358, 72.2%, 69%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 72.2%, 69%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "300"
          ]
        },
        "350": {
          "value": "hsla(357, 82.4%, 68.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(357, 82.4%, 68.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "350"
          ]
        },
        "400": {
          "value": "hsla(358, 74.9%, 61%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 74.9%, 61%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "400"
          ]
        },
        "450": {
          "value": "hsla(357, 84.2%, 62.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(357, 84.2%, 62.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "450"
          ]
        },
        "500": {
          "value": "hsla(359, 68.4%, 49.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(359, 68.4%, 49.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "500"
          ]
        },
        "550": {
          "value": "hsla(358, 82.4%, 57.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 82.4%, 57.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "550"
          ]
        },
        "600": {
          "value": "hsla(359, 74%, 45.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(359, 74%, 45.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "600"
          ]
        },
        "650": {
          "value": "hsla(358, 85.3%, 42.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 85.3%, 42.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "650"
          ]
        },
        "700": {
          "value": "hsla(359, 80.7%, 38.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(359, 80.7%, 38.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "700"
          ]
        },
        "750": {
          "value": "hsla(359, 89.4%, 33.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(359, 89.4%, 33.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "750"
          ]
        },
        "800": {
          "value": "hsla(358, 87.8%, 25.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(358, 87.8%, 25.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "800"
          ]
        },
        "850": {
          "value": "hsla(359, 92.9%, 22%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(359, 92.9%, 22%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "850"
          ]
        },
        "900": {
          "value": "hsla(359, 93.9%, 12.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(359, 93.9%, 12.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-red-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "red",
            "900"
          ]
        }
      },
      "yellow": {
        "50": {
          "value": "hsla(50, 69.7%, 93.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(50, 69.7%, 93.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "50"
          ]
        },
        "100": {
          "value": "hsla(48, 80.6%, 81.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(48, 80.6%, 81.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "100"
          ]
        },
        "200": {
          "value": "hsla(47, 91%, 73.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(47, 91%, 73.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "200"
          ]
        },
        "300": {
          "value": "hsla(46, 95.2%, 67.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(46, 95.2%, 67.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "300"
          ]
        },
        "350": {
          "value": "hsla(46, 97.9%, 62.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(46, 97.9%, 62.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "350"
          ]
        },
        "400": {
          "value": "hsla(41, 90.5%, 58.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(41, 90.5%, 58.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "400"
          ]
        },
        "500": {
          "value": "hsla(36, 84%, 55.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(36, 84%, 55.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "500"
          ]
        },
        "600": {
          "value": "hsla(33, 74%, 51.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(33, 74%, 51.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "600"
          ]
        },
        "700": {
          "value": "hsla(27, 70%, 35.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(27, 70%, 35.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "700"
          ]
        },
        "800": {
          "value": "hsla(26, 68.4%, 22.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(26, 68.4%, 22.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "800"
          ]
        },
        "900": {
          "value": "hsla(26, 63.1%, 12.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(26, 63.1%, 12.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-yellow-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "yellow",
            "900"
          ]
        }
      },
      "purple": {
        "50": {
          "value": "hsla(256, 52.4%, 91.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 52.4%, 91.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "50"
          ]
        },
        "100": {
          "value": "hsla(256, 68%, 85.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 68%, 85.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "100"
          ]
        },
        "150": {
          "value": "hsla(256, 75%, 84.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 75%, 84.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "150"
          ]
        },
        "200": {
          "value": "hsla(256, 74.8%, 78.2%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 74.8%, 78.2%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "200"
          ]
        },
        "250": {
          "value": "hsla(256, 83.1%, 76.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 83.1%, 76.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "250"
          ]
        },
        "300": {
          "value": "hsla(256, 77.9%, 69.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 77.9%, 69.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "300"
          ]
        },
        "350": {
          "value": "hsla(256, 85.6%, 70%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 85.6%, 70%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "350"
          ]
        },
        "400": {
          "value": "hsla(256, 78.1%, 57.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 78.1%, 57.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "400"
          ]
        },
        "450": {
          "value": "hsla(256, 84.9%, 58.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 84.9%, 58.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "450"
          ]
        },
        "500": {
          "value": "hsla(256, 74.8%, 53.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 74.8%, 53.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "500"
          ]
        },
        "550": {
          "value": "hsla(256, 81.5%, 53.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 81.5%, 53.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "550"
          ]
        },
        "600": {
          "value": "hsla(256, 72.3%, 49.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 72.3%, 49.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "600"
          ]
        },
        "650": {
          "value": "hsla(256, 88%, 42.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 88%, 42.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "650"
          ]
        },
        "700": {
          "value": "hsla(256, 85.7%, 38.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 85.7%, 38.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "700"
          ]
        },
        "750": {
          "value": "hsla(256, 94%, 32.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 94%, 32.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "750"
          ]
        },
        "800": {
          "value": "hsla(256, 92.3%, 25.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 92.3%, 25.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "800"
          ]
        },
        "850": {
          "value": "hsla(256, 98.2%, 21.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 98.2%, 21.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "850"
          ]
        },
        "900": {
          "value": "hsla(256, 100%, 12.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(256, 100%, 12.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-purple-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "purple",
            "900"
          ]
        }
      },
      "darkTeal": {
        "50": {
          "value": "hsla(186, 94%, 91%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 94%, 91%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "50"
          ]
        },
        "100": {
          "value": "hsla(186, 93%, 77%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 93%, 77%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "100"
          ]
        },
        "200": {
          "value": "hsla(186, 78%, 69%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 78%, 69%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "200"
          ]
        },
        "300": {
          "value": "hsla(186, 67%, 59%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 67%, 59%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "300"
          ]
        },
        "400": {
          "value": "hsla(187, 50%, 47%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(187, 50%, 47%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "400"
          ]
        },
        "500": {
          "value": "hsla(187, 41%, 38%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(187, 41%, 38%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "500"
          ]
        },
        "600": {
          "value": "hsla(190, 38%, 31%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(190, 38%, 31%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "600"
          ]
        },
        "700": {
          "value": "hsla(190, 30%, 25%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(190, 30%, 25%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "700"
          ]
        },
        "800": {
          "value": "hsla(195, 25%, 16%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(195, 25%, 16%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "800"
          ]
        },
        "900": {
          "value": "hsla(189, 16%, 8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(189, 16%, 8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-dark-teal-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "darkTeal",
            "900"
          ]
        }
      },
      "lightTeal": {
        "50": {
          "value": "hsla(186, 69%, 83%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 69%, 83%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "50"
          ]
        },
        "100": {
          "value": "hsla(186, 69%, 73%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 69%, 73%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "100"
          ]
        },
        "200": {
          "value": "hsla(186, 58%, 66%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 58%, 66%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "200"
          ]
        },
        "300": {
          "value": "hsla(186, 44%, 56%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(186, 44%, 56%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "300"
          ]
        },
        "400": {
          "value": "hsla(187, 40%, 45%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(187, 40%, 45%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "400"
          ]
        },
        "500": {
          "value": "hsla(187, 50%, 35%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(187, 50%, 35%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "500"
          ]
        },
        "600": {
          "value": "hsla(190, 46%, 30%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(190, 46%, 30%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "600"
          ]
        },
        "700": {
          "value": "hsla(190, 30%, 23%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(190, 30%, 23%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "700"
          ]
        },
        "800": {
          "value": "hsla(195, 25%, 16%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(195, 25%, 16%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "800"
          ]
        },
        "900": {
          "value": "hsla(189, 16%, 8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(189, 16%, 8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-light-teal-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "lightTeal",
            "900"
          ]
        }
      },
      "neutralWarm": {
        "50": {
          "value": "hsla(326, 30.4%, 95.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(326, 30.4%, 95.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "50"
          ]
        },
        "100": {
          "value": "hsla(327, 13%, 86.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 13%, 86.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "100"
          ]
        },
        "150": {
          "value": "hsla(330, 11.4%, 86.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(330, 11.4%, 86.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "150"
          ]
        },
        "200": {
          "value": "hsla(324, 8.6%, 77.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(324, 8.6%, 77.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "200"
          ]
        },
        "250": {
          "value": "hsla(327, 7.7%, 77.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 7.7%, 77.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "250"
          ]
        },
        "300": {
          "value": "hsla(327, 6.7%, 68%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 6.7%, 68%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "300"
          ]
        },
        "350": {
          "value": "hsla(327, 5.5%, 68%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 5.5%, 68%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "350"
          ]
        },
        "400": {
          "value": "hsla(327, 5.3%, 59.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 5.3%, 59.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "400"
          ]
        },
        "450": {
          "value": "hsla(327, 4.3%, 59%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 4.3%, 59%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "450"
          ]
        },
        "500": {
          "value": "hsla(327, 4.2%, 41.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(327, 4.2%, 41.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "500"
          ]
        },
        "550": {
          "value": "hsla(323, 3.8%, 41.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(323, 3.8%, 41.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "550"
          ]
        },
        "600": {
          "value": "hsla(326, 4.1%, 33.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(326, 4.1%, 33.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "600"
          ]
        },
        "700": {
          "value": "hsla(330, 4.8%, 24.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(330, 4.8%, 24.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "700"
          ]
        },
        "750": {
          "value": "hsla(324, 4%, 24.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(324, 4%, 24.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "750"
          ]
        },
        "800": {
          "value": "hsla(330, 4.9%, 16.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(330, 4.9%, 16.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "800"
          ]
        },
        "900": {
          "value": "hsla(300, 2.6%, 7.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(300, 2.6%, 7.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-warm-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralWarm",
            "900"
          ]
        }
      },
      "neutralCool": {
        "50": {
          "value": "hsla(212, 54.3%, 93.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(212, 54.3%, 93.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "50"
          ]
        },
        "55": {
          "value": "hsla(212, 30.2%, 91.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(212, 30.2%, 91.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-55",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "55"
          ]
        },
        "100": {
          "value": "hsla(213, 25%, 84.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(213, 25%, 84.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "100"
          ]
        },
        "150": {
          "value": "hsla(210, 21.2%, 87.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 21.2%, 87.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "150"
          ]
        },
        "200": {
          "value": "hsla(213, 15.9%, 75.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(213, 15.9%, 75.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "200"
          ]
        },
        "250": {
          "value": "hsla(214, 18.2%, 82.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(214, 18.2%, 82.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "250"
          ]
        },
        "300": {
          "value": "hsla(213, 11.6%, 66.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(213, 11.6%, 66.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "300"
          ]
        },
        "350": {
          "value": "hsla(212, 12.8%, 73.9%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(212, 12.8%, 73.9%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "350"
          ]
        },
        "400": {
          "value": "hsla(215, 8.8%, 57.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(215, 8.8%, 57.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "400"
          ]
        },
        "450": {
          "value": "hsla(215, 9.6%, 65.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(215, 9.6%, 65.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "450"
          ]
        },
        "500": {
          "value": "hsla(214, 6.7%, 40.8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(214, 6.7%, 40.8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "500"
          ]
        },
        "550": {
          "value": "hsla(215, 7.7%, 56.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(215, 7.7%, 56.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "550"
          ]
        },
        "600": {
          "value": "hsla(213, 6.7%, 32.4%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(213, 6.7%, 32.4%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "600"
          ]
        },
        "650": {
          "value": "hsla(214, 6.9%, 40%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(214, 6.9%, 40%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "650"
          ]
        },
        "700": {
          "value": "hsla(213, 7.3%, 24.1%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(213, 7.3%, 24.1%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "700"
          ]
        },
        "750": {
          "value": "hsla(217, 6.7%, 23.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(217, 6.7%, 23.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "750"
          ]
        },
        "800": {
          "value": "hsla(216, 8.5%, 11.6%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(216, 8.5%, 11.6%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "800"
          ]
        },
        "850": {
          "value": "hsla(216, 6.3%, 15.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(216, 6.3%, 15.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "850"
          ]
        },
        "900": {
          "value": "hsla(210, 5.3%, 7.5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5.3%, 7.5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-neutral-cool-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "neutralCool",
            "900"
          ]
        }
      },
      "surfaceElevation": {
        "50": {
          "value": "hsla(220, 6%, 20%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(220, 6%, 20%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "50"
          ]
        },
        "100": {
          "value": "hsla(216, 5%, 18%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(216, 5%, 18%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "100"
          ]
        },
        "200": {
          "value": "hsla(216, 6%, 17%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(216, 6%, 17%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "200"
          ]
        },
        "300": {
          "value": "hsla(210, 5%, 15%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 15%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "300"
          ]
        },
        "400": {
          "value": "hsla(225, 6%, 14%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(225, 6%, 14%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "400"
          ]
        },
        "500": {
          "value": "hsla(220, 5%, 13%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(220, 5%, 13%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "500"
          ]
        },
        "600": {
          "value": "hsla(220, 5%, 11%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(220, 5%, 11%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "600"
          ]
        },
        "700": {
          "value": "hsla(210, 4%, 10%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 4%, 10%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "700"
          ]
        },
        "800": {
          "value": "hsla(240, 2%, 8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 2%, 8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "800"
          ]
        },
        "900": {
          "value": "hsla(240, 3%, 5%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 3%, 5%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-elevation-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceElevation",
            "900"
          ]
        }
      },
      "surfaceLayer": {
        "50": {
          "value": "hsla(240, 5%, 25%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 25%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "50"
          ]
        },
        "55": {
          "value": "hsla(240, 5%, 97%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 97%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-55",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "55"
          ]
        },
        "100": {
          "value": "hsla(240, 5%, 22%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 22%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "100"
          ]
        },
        "150": {
          "value": "hsla(240, 5%, 96%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 96%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "150"
          ]
        },
        "200": {
          "value": "hsla(240, 5%, 19%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 19%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "200"
          ]
        },
        "250": {
          "value": "hsla(240, 5%, 95%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 95%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "250"
          ]
        },
        "300": {
          "value": "hsla(240, 4%, 17%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 4%, 17%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "300"
          ]
        },
        "350": {
          "value": "hsla(240, 5%, 94%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 94%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "350"
          ]
        },
        "400": {
          "value": "hsla(240, 5%, 15%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 15%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "400"
          ]
        },
        "450": {
          "value": "hsla(240, 5%, 93%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 93%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "450"
          ]
        },
        "500": {
          "value": "hsla(240, 6%, 14%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 6%, 14%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "500"
          ]
        },
        "550": {
          "value": "hsla(240, 5%, 92%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 92%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "550"
          ]
        },
        "600": {
          "value": "hsla(240, 5%, 13%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 13%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "600"
          ]
        },
        "650": {
          "value": "hsla(240, 5%, 91%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 91%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "650"
          ]
        },
        "700": {
          "value": "hsla(240, 5%, 11%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 11%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "700"
          ]
        },
        "750": {
          "value": "hsla(240, 5%, 90%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 90%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "750"
          ]
        },
        "800": {
          "value": "hsla(240, 4%, 10%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 4%, 10%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "800"
          ]
        },
        "850": {
          "value": "hsla(240, 5%, 89%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 89%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "850"
          ]
        },
        "900": {
          "value": "hsla(240, 2%, 8%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 2%, 8%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "900"
          ]
        },
        "950": {
          "value": "hsla(240, 5%, 88%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(240, 5%, 88%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-surface-layer-950",
          "attributes": {},
          "path": [
            "color",
            "base",
            "surfaceLayer",
            "950"
          ]
        }
      },
      "primaryBorder": {
        "50": {
          "value": "hsla(320, 27%, 98%, 0.9)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.9)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-50",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "50"
          ]
        },
        "55": {
          "value": "hsla(210, 5%, 7%, 0.05)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.05)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-55",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "55"
          ]
        },
        "100": {
          "value": "hsla(320, 27%, 98%, 0.8)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.8)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-100",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "100"
          ]
        },
        "150": {
          "value": "hsla(210, 5%, 7%, 0.1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-150",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "150"
          ]
        },
        "200": {
          "value": "hsla(320, 27%, 98%, 0.7)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.7)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-200",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "200"
          ]
        },
        "250": {
          "value": "hsla(210, 5%, 7%, 0.2)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.2)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-250",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "250"
          ]
        },
        "300": {
          "value": "hsla(320, 27%, 98%, 0.5)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.5)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-300",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "300"
          ]
        },
        "350": {
          "value": "hsla(210, 5%, 7%, 0.3)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.3)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-350",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "350"
          ]
        },
        "400": {
          "value": "hsla(320, 27%, 98%, 0.6)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.6)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-400",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "400"
          ]
        },
        "450": {
          "value": "hsla(210, 5%, 7%, 0.4)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.4)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-450",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "450"
          ]
        },
        "500": {
          "value": "hsla(320, 27%, 98%, 0.4)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.4)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-500",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "500"
          ]
        },
        "550": {
          "value": "hsla(210, 5%, 7%, 0.5)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.5)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-550",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "550"
          ]
        },
        "600": {
          "value": "hsla(320, 27%, 98%, 0.3)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.3)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-600",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "600"
          ]
        },
        "650": {
          "value": "hsla(210, 5%, 7%, 0.6)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.6)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-650",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "650"
          ]
        },
        "700": {
          "value": "hsla(320, 27%, 98%, 0.2)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.2)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-700",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "700"
          ]
        },
        "750": {
          "value": "hsla(210, 5%, 7%, 0.7)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.7)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-750",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "750"
          ]
        },
        "800": {
          "value": "hsla(320, 27%, 98%, 0.1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-800",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "800"
          ]
        },
        "850": {
          "value": "hsla(210, 5%, 7%, 0.8)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.8)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-850",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "850"
          ]
        },
        "900": {
          "value": "hsla(320, 27%, 98%, 0.05)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(320, 27%, 98%, 0.05)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-900",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "900"
          ]
        },
        "950": {
          "value": "hsla(210, 5%, 7%, 0.9)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(210, 5%, 7%, 0.9)",
            "type": "color"
          },
          "name": "hb-ds-color-base-primary-border-950",
          "attributes": {},
          "path": [
            "color",
            "base",
            "primaryBorder",
            "950"
          ]
        }
      },
      "constant": {
        "black": {
          "value": "hsla(0, 0%, 0%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(0, 0%, 0%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-black",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "black"
          ]
        },
        "white": {
          "value": "hsla(0, 0%, 100%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(0, 0%, 100%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-white",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "white"
          ]
        },
        "homebot": {
          "value": "hsla(334, 92.3%, 64.3%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(334, 92.3%, 64.3%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-homebot",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "homebot"
          ]
        },
        "homebotFill": {
          "value": "hsla(266, 14%, 20%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(266, 14%, 20%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-homebot-fill",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "homebotFill"
          ]
        },
        "coreLogic": {
          "value": "hsla(8, 78.8%, 52%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(8, 78.8%, 52%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-core-logic",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "coreLogic"
          ]
        },
        "realtyTrac": {
          "value": "hsla(282, 78.8%, 52%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(282, 78.8%, 52%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-realty-trac",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "realtyTrac"
          ]
        },
        "zillow": {
          "value": "hsla(209, 100%, 44.7%, 1)",
          "type": "color",
          "filePath": "tokens/globals/colors.json",
          "isSource": true,
          "original": {
            "value": "hsla(209, 100%, 44.7%, 1)",
            "type": "color"
          },
          "name": "hb-ds-color-base-constant-zillow",
          "attributes": {},
          "path": [
            "color",
            "base",
            "constant",
            "zillow"
          ]
        }
      }
    }
  },
  "spacing": {
    "0": {
      "value": "0px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "0",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-0",
      "attributes": {},
      "path": [
        "spacing",
        "0"
      ]
    },
    "100": {
      "value": "1px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 0.0625, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-100",
      "attributes": {},
      "path": [
        "spacing",
        "100"
      ]
    },
    "200": {
      "value": "2px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 0.125, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-200",
      "attributes": {},
      "path": [
        "spacing",
        "200"
      ]
    },
    "300": {
      "value": "4px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 0.25, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-300",
      "attributes": {},
      "path": [
        "spacing",
        "300"
      ]
    },
    "400": {
      "value": "8px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 0.5, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-400",
      "attributes": {},
      "path": [
        "spacing",
        "400"
      ]
    },
    "500": {
      "value": "16px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 1, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-500",
      "attributes": {},
      "path": [
        "spacing",
        "500"
      ]
    },
    "600": {
      "value": "24px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 1.5, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-600",
      "attributes": {},
      "path": [
        "spacing",
        "600"
      ]
    },
    "700": {
      "value": "28px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 1.75, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-700",
      "attributes": {},
      "path": [
        "spacing",
        "700"
      ]
    },
    "800": {
      "value": "32px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 2, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-800",
      "attributes": {},
      "path": [
        "spacing",
        "800"
      ]
    },
    "900": {
      "value": "48px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 3, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-900",
      "attributes": {},
      "path": [
        "spacing",
        "900"
      ]
    },
    "1000": {
      "value": "72px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 4.5, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-1000",
      "attributes": {},
      "path": [
        "spacing",
        "1000"
      ]
    },
    "1100": {
      "value": "96px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 6, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-1100",
      "attributes": {},
      "path": [
        "spacing",
        "1100"
      ]
    },
    "1200": {
      "value": "128px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 8, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-1200",
      "attributes": {},
      "path": [
        "spacing",
        "1200"
      ]
    },
    "1300": {
      "value": "144px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 9, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-1300",
      "attributes": {},
      "path": [
        "spacing",
        "1300"
      ]
    },
    "1400": {
      "value": "168px",
      "type": "spacing",
      "filePath": "tokens/globals/spacing.json",
      "isSource": true,
      "original": {
        "value": "roundTo({spacing.scale.baseUnit} * {spacing.scale.ratio} * 10.5, 0)",
        "type": "spacing"
      },
      "name": "hb-ds-spacing-1400",
      "attributes": {},
      "path": [
        "spacing",
        "1400"
      ]
    },
    "scale": {
      "baseUnit": {
        "value": "16",
        "filePath": "tokens/globals/spacing.json",
        "isSource": true,
        "original": {
          "value": "16"
        },
        "name": "hb-ds-spacing-scale-base-unit",
        "attributes": {},
        "path": [
          "spacing",
          "scale",
          "baseUnit"
        ]
      },
      "ratio": {
        "value": "1",
        "filePath": "tokens/globals/spacing.json",
        "isSource": true,
        "original": {
          "value": "1"
        },
        "name": "hb-ds-spacing-scale-ratio",
        "attributes": {},
        "path": [
          "spacing",
          "scale",
          "ratio"
        ]
      }
    }
  },
  "semantic": {
    "fontFamilies": {
      "headings": {
        "value": "Open Sans",
        "type": "fontFamilies",
        "filePath": "tokens/semantic.json",
        "isSource": true,
        "original": {
          "value": "{globals.fontFamilies.base}",
          "type": "fontFamilies"
        },
        "name": "hb-ds-semantic-font-families-headings",
        "attributes": {},
        "path": [
          "semantic",
          "fontFamilies",
          "headings"
        ]
      }
    },
    "fontWeights": {
      "headings": {
        "light": {
          "value": "300",
          "type": "fontWeights",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{globals.fontWeights.light}",
            "type": "fontWeights"
          },
          "name": "hb-ds-semantic-font-weights-headings-light",
          "attributes": {},
          "path": [
            "semantic",
            "fontWeights",
            "headings",
            "light"
          ]
        },
        "regular": {
          "value": "400",
          "type": "fontWeights",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{globals.fontWeights.regular}",
            "type": "fontWeights"
          },
          "name": "hb-ds-semantic-font-weights-headings-regular",
          "attributes": {},
          "path": [
            "semantic",
            "fontWeights",
            "headings",
            "regular"
          ]
        },
        "semibold": {
          "value": "600",
          "type": "fontWeights",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{globals.fontWeights.semibold}",
            "type": "fontWeights"
          },
          "name": "hb-ds-semantic-font-weights-headings-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "fontWeights",
            "headings",
            "semibold"
          ]
        },
        "bold": {
          "value": "700",
          "type": "fontWeights",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{globals.fontWeights.bold}",
            "type": "fontWeights"
          },
          "name": "hb-ds-semantic-font-weights-headings-bold",
          "attributes": {},
          "path": [
            "semantic",
            "fontWeights",
            "headings",
            "bold"
          ]
        }
      }
    },
    "typography": {
      "heading100": {
        "light": {
          "value": "300 12.5px/160% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.light}",
              "lineHeight": "{globals.lineHeights.200}",
              "fontSize": "{globals.fontSize.200}",
              "letterSpacing": "{globals.letterSpacing.200}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading100-light",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading100",
            "light"
          ]
        },
        "regular": {
          "value": "400 12.5px/160% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.regular}",
              "lineHeight": "{globals.lineHeights.200}",
              "fontSize": "{globals.fontSize.200}",
              "letterSpacing": "{globals.letterSpacing.200}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading100-regular",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading100",
            "regular"
          ]
        },
        "semibold": {
          "value": "600 12.5px/160% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.semibold}",
              "lineHeight": "{globals.lineHeights.200}",
              "fontSize": "{globals.fontSize.200}",
              "letterSpacing": "{globals.letterSpacing.200}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading100-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading100",
            "semibold"
          ]
        },
        "bold": {
          "value": "700 12.5px/160% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.bold}",
              "lineHeight": "{globals.lineHeights.200}",
              "fontSize": "{globals.fontSize.200}",
              "letterSpacing": "{globals.letterSpacing.200}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading100-bold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading100",
            "bold"
          ]
        }
      },
      "heading200": {
        "light": {
          "value": "300 14px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.light}",
              "lineHeight": "{globals.lineHeights.300}",
              "fontSize": "{globals.fontSize.300}",
              "letterSpacing": "{globals.letterSpacing.300}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading200-light",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading200",
            "light"
          ]
        },
        "regular": {
          "value": "400 14px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.regular}",
              "lineHeight": "{globals.lineHeights.300}",
              "fontSize": "{globals.fontSize.300}",
              "letterSpacing": "{globals.letterSpacing.300}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading200-regular",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading200",
            "regular"
          ]
        },
        "semibold": {
          "value": "600 14px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.semibold}",
              "lineHeight": "{globals.lineHeights.300}",
              "fontSize": "{globals.fontSize.300}",
              "letterSpacing": "{globals.letterSpacing.300}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading200-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading200",
            "semibold"
          ]
        },
        "bold": {
          "value": "700 14px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.bold}",
              "lineHeight": "{globals.lineHeights.300}",
              "fontSize": "{globals.fontSize.300}",
              "letterSpacing": "{globals.letterSpacing.300}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading200-bold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading200",
            "bold"
          ]
        }
      },
      "heading300": {
        "light": {
          "value": "300 17px/141.2% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.light}",
              "lineHeight": "{globals.lineHeights.500}",
              "fontSize": "{globals.fontSize.500}",
              "letterSpacing": "{globals.letterSpacing.500}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading300-light",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading300",
            "light"
          ]
        },
        "regular": {
          "value": "400 17px/141.2% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.regular}",
              "lineHeight": "{globals.lineHeights.500}",
              "fontSize": "{globals.fontSize.500}",
              "letterSpacing": "{globals.letterSpacing.500}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading300-regular",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading300",
            "regular"
          ]
        },
        "semibold": {
          "value": "600 17px/141.2% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.semibold}",
              "lineHeight": "{globals.lineHeights.500}",
              "fontSize": "{globals.fontSize.500}",
              "letterSpacing": "{globals.letterSpacing.500}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading300-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading300",
            "semibold"
          ]
        },
        "bold": {
          "value": "700 17px/141.2% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.bold}",
              "lineHeight": "{globals.lineHeights.500}",
              "fontSize": "{globals.fontSize.500}",
              "letterSpacing": "{globals.letterSpacing.500}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading300-bold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading300",
            "bold"
          ]
        }
      },
      "heading400": {
        "light": {
          "value": "300 21px/152.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.light}",
              "lineHeight": "{globals.lineHeights.600}",
              "fontSize": "{globals.fontSize.600}",
              "letterSpacing": "{globals.letterSpacing.600}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading400-light",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading400",
            "light"
          ]
        },
        "regular": {
          "value": "400 21px/152.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.regular}",
              "lineHeight": "{globals.lineHeights.600}",
              "fontSize": "{globals.fontSize.600}",
              "letterSpacing": "{globals.letterSpacing.600}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading400-regular",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading400",
            "regular"
          ]
        },
        "semibold": {
          "value": "600 21px/152.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.semibold}",
              "lineHeight": "{globals.lineHeights.600}",
              "fontSize": "{globals.fontSize.600}",
              "letterSpacing": "{globals.letterSpacing.600}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading400-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading400",
            "semibold"
          ]
        },
        "bold": {
          "value": "700 21px/152.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.bold}",
              "lineHeight": "{globals.lineHeights.600}",
              "fontSize": "{globals.fontSize.600}",
              "letterSpacing": "{globals.letterSpacing.600}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading400-bold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading400",
            "bold"
          ]
        }
      },
      "heading500": {
        "light": {
          "value": "300 28px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.light}",
              "lineHeight": "{globals.lineHeights.700}",
              "fontSize": "{globals.fontSize.700}",
              "letterSpacing": "{globals.letterSpacing.700}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading500-light",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading500",
            "light"
          ]
        },
        "regular": {
          "value": "400 28px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.regular}",
              "lineHeight": "{globals.lineHeights.700}",
              "fontSize": "{globals.fontSize.700}",
              "letterSpacing": "{globals.letterSpacing.700}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading500-regular",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading500",
            "regular"
          ]
        },
        "semibold": {
          "value": "600 28px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.semibold}",
              "lineHeight": "{globals.lineHeights.700}",
              "fontSize": "{globals.fontSize.700}",
              "letterSpacing": "{globals.letterSpacing.700}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading500-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading500",
            "semibold"
          ]
        },
        "bold": {
          "value": "700 28px/142.9% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.bold}",
              "lineHeight": "{globals.lineHeights.700}",
              "fontSize": "{globals.fontSize.700}",
              "letterSpacing": "{globals.letterSpacing.700}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading500-bold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading500",
            "bold"
          ]
        }
      },
      "heading600": {
        "light": {
          "value": "300 34px/129.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.light}",
              "lineHeight": "{globals.lineHeights.800}",
              "fontSize": "{globals.fontSize.800}",
              "letterSpacing": "{globals.letterSpacing.800}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading600-light",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading600",
            "light"
          ]
        },
        "regular": {
          "value": "400 34px/129.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.regular}",
              "lineHeight": "{globals.lineHeights.800}",
              "fontSize": "{globals.fontSize.800}",
              "letterSpacing": "{globals.letterSpacing.800}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading600-regular",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading600",
            "regular"
          ]
        },
        "semibold": {
          "value": "600 34px/129.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.semibold}",
              "lineHeight": "{globals.lineHeights.800}",
              "fontSize": "{globals.fontSize.800}",
              "letterSpacing": "{globals.letterSpacing.800}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading600-semibold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading600",
            "semibold"
          ]
        },
        "bold": {
          "value": "700 34px/129.4% Open Sans",
          "type": "typography",
          "filePath": "tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": {
              "fontFamily": "{semantic.fontFamilies.headings}",
              "fontWeight": "{semantic.fontWeights.headings.bold}",
              "lineHeight": "{globals.lineHeights.800}",
              "fontSize": "{globals.fontSize.800}",
              "letterSpacing": "{globals.letterSpacing.800}"
            },
            "type": "typography"
          },
          "name": "hb-ds-semantic-typography-heading600-bold",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "heading600",
            "bold"
          ]
        }
      },
      "color": {
        "neutral": {
          "value": "hsla(0, 0%, 0%, 1)",
          "type": "color",
          "filePath": "tokens/homebotCore/100_admin.json",
          "isSource": true,
          "original": {
            "value": "{color.base.constant.black}",
            "type": "color"
          },
          "name": "hb-ds-semantic-typography-color-neutral",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "color",
            "neutral"
          ]
        },
        "warning": {
          "value": "hsla(24, 82.8%, 54.3%, 1)",
          "type": "color",
          "filePath": "tokens/homebotCore/100_admin.json",
          "isSource": true,
          "original": {
            "value": "{color.base.orange.550}",
            "type": "color"
          },
          "name": "hb-ds-semantic-typography-color-warning",
          "attributes": {},
          "path": [
            "semantic",
            "typography",
            "color",
            "warning"
          ]
        }
      }
    },
    "backgroundImage": {
      "value": "radial-gradient(88.02% 32.04% at 50% 7.61%, #FFFFFF 0%, #E9E9EC 100%)",
      "type": "other",
      "filePath": "tokens/homebotCore/100_admin.json",
      "isSource": true,
      "original": {
        "value": "radial-gradient(88.02% 32.04% at 50% 7.61%, #FFFFFF 0%, #E9E9EC 100%)",
        "type": "other"
      },
      "name": "hb-ds-semantic-background-image",
      "attributes": {},
      "path": [
        "semantic",
        "backgroundImage"
      ]
    }
  },
  "headings": {
    "h1": {
      "spacing": {
        "marginBottom": {
          "value": "28px",
          "type": "spacing",
          "filePath": "tokens/components/h1.json",
          "isSource": true,
          "original": {
            "value": "{spacing.700}",
            "type": "spacing"
          },
          "name": "hb-ds-headings-h1-spacing-margin-bottom",
          "attributes": {},
          "path": [
            "headings",
            "h1",
            "spacing",
            "marginBottom"
          ]
        }
      }
    },
    "h2": {
      "spacing": {
        "marginBottom": {
          "value": "24px",
          "type": "spacing",
          "filePath": "tokens/components/h2.json",
          "isSource": true,
          "original": {
            "value": "{spacing.600}",
            "type": "spacing"
          },
          "name": "hb-ds-headings-h2-spacing-margin-bottom",
          "attributes": {},
          "path": [
            "headings",
            "h2",
            "spacing",
            "marginBottom"
          ]
        }
      }
    },
    "h3": {
      "spacing": {
        "marginBottom": {
          "value": "28px",
          "type": "spacing",
          "filePath": "tokens/components/h3.json",
          "isSource": true,
          "original": {
            "value": "{spacing.700}",
            "type": "spacing"
          },
          "name": "hb-ds-headings-h3-spacing-margin-bottom",
          "attributes": {},
          "path": [
            "headings",
            "h3",
            "spacing",
            "marginBottom"
          ]
        }
      }
    },
    "h4": {
      "spacing": {
        "marginBottom": {
          "value": "8px",
          "type": "spacing",
          "filePath": "tokens/components/h4.json",
          "isSource": true,
          "original": {
            "value": "{spacing.400}",
            "type": "spacing"
          },
          "name": "hb-ds-headings-h4-spacing-margin-bottom",
          "attributes": {},
          "path": [
            "headings",
            "h4",
            "spacing",
            "marginBottom"
          ]
        }
      }
    },
    "h5": {
      "spacing": {
        "marginBottom": {
          "value": "16px",
          "type": "spacing",
          "filePath": "tokens/components/h5.json",
          "isSource": true,
          "original": {
            "value": "{spacing.500}",
            "type": "spacing"
          },
          "name": "hb-ds-headings-h5-spacing-margin-bottom",
          "attributes": {},
          "path": [
            "headings",
            "h5",
            "spacing",
            "marginBottom"
          ]
        }
      }
    },
    "h6": {
      "spacing": {
        "marginBottom": {
          "value": "4px",
          "type": "spacing",
          "filePath": "tokens/components/h6.json",
          "isSource": true,
          "original": {
            "value": "{spacing.300}",
            "type": "spacing"
          },
          "name": "hb-ds-headings-h6-spacing-margin-bottom",
          "attributes": {},
          "path": [
            "headings",
            "h6",
            "spacing",
            "marginBottom"
          ]
        }
      }
    }
  }
};